<basket-header-content
    (basketOpened)="open()"
    [supplierBaskets]="supplierBaskets$ | async"
></basket-header-content>
